import React from 'react';
import { useNavigate } from 'react-router-dom';

const ThankYou = () => {
    const navigate = useNavigate();

    return (
        <div className="min-h-screen flex flex-col justify-center items-center bg-gradient-to-r from-green-100 to-blue-100">
            <div className="bg-white shadow-lg rounded-lg p-8 max-w-lg text-center">
                <div className="mb-6">
                    <img
                        src="https://cdn-icons-png.flaticon.com/512/148/148767.png"
                        alt="Success Icon"
                        className="w-24 mx-auto"
                    />
                </div>
                <h1 className="text-3xl font-bold text-green-600 mb-4">অভিনন্দন!</h1>
                <p className="text-gray-700 text-lg">
                    আপনার পেমেন্ট সফল হয়েছে! আমাদের সার্ভিস/মেম্বারশীপ নেওয়ার জন্য আপনাকে ধন্যবাদ।
                </p>
                <p className="mt-2 text-gray-600">
                    আমরা আপনার সাথেই রয়েছি। খুব শীঘ্রই আপনি ইমেইলে আরও বিস্তারিত তথ্য পাবেন।
                </p>
                <div className="mt-6">
                    <button
                        onClick={() => navigate('/register')}
                        className="px-6 py-3 bg-indigo-600 text-white font-semibold rounded-md shadow-sm hover:bg-indigo-700"
                    >
                        ড্যাশবোর্ডে প্রবেশ করতে রেজিস্ট্রেশন করুন
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ThankYou;
